import { useState } from "react";
import { saveCompanyLocation } from "../Api/CompanyLocationMaster";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Container,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const CompanyLocationMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [companyLocationData, setCompanyLocationData] = useState({
    registrationNumber: "",
    cityId: "",
    stateId: "",
    companyName: "",
  });

  const handleChange = (e) => {
    setCompanyLocationData({
      ...companyLocationData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCompanyLocation(companyLocationData, userId);
      toast.success(`🦄 Company Location Added Successfully`);
      setCompanyLocationData({
        registrationNumber: "",
        cityId: "",
        stateId: "",
        companyName: "",
      });
      navigate("/companyLocationMaster");
    } catch (error) {
      toast.error(`🦄 Error saving company location: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container company-location-master-fields">
      <h2 className="fields-title">Company Location Master</h2>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}

      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion
          defaultActiveKey="0"
          className="company-location-master-accordion"
        >
          <AccordionItem eventKey="0">
            <AccordionBody>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Registration Number <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="registrationNumber"
                      value={companyLocationData.registrationNumber}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      City ID <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="cityId"
                      value={companyLocationData.cityId}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      State ID <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="stateId"
                      value={companyLocationData.stateId}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Company Name <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="companyName"
                      value={companyLocationData.companyName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            </AccordionBody>
          </AccordionItem>
        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Company Location"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CompanyLocationMaster;
